import React, { useState } from 'react';
import { Share2, Gift, Users, Award, Copy, Check } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Button } from '../common/Button';

export const ReferralPage: React.FC = () => {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  const referralCode = user?.id.slice(0, 8) || '';
  const referralLink = `https://celestialguide.app/convite/${referralCode}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      toast.success('Link copiado com sucesso!');
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      toast.error('Erro ao copiar link');
    }
  };

  const rewards = [
    {
      title: '3 Amigos',
      description: '50 créditos + 1 consulta grátis',
      icon: Users,
      unlocked: false,
    },
    {
      title: '5 Amigos',
      description: '100 créditos + mapa astral completo',
      icon: Award,
      unlocked: false,
    },
    {
      title: '10 Amigos',
      description: '200 créditos + 3 consultas grátis',
      icon: Gift,
      unlocked: false,
    },
  ];

  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)] space-y-6">
      <div className="flex items-center space-x-4 mb-8">
        <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
          <Share2 className="w-8 h-8 text-purple-300" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-purple-200">Indique e Ganhe</h2>
          <p className="text-purple-300/70">Convide amigos e receba recompensas</p>
        </div>
      </div>

      <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6">
        <h3 className="text-lg font-medium text-purple-200 mb-4">Seu Link de Convite</h3>
        <div className="flex items-center space-x-2">
          <input
            type="text"
            value={referralLink}
            readOnly
            className="flex-1 input-primary"
          />
          <Button
            onClick={handleCopy}
            variant="secondary"
            icon={copied ? <Check className="w-4 h-4 text-green-400" /> : <Copy className="w-4 h-4" />}
          >
            {copied ? 'Copiado!' : 'Copiar'}
          </Button>
        </div>
      </div>

      <div className="bg-white/10 backdrop-blur-lg rounded-lg p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-medium text-purple-200">Seu Progresso</h3>
          <span className="text-purple-200">0/10 amigos</span>
        </div>
        <div className="w-full h-2 bg-white/10 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-purple-500 to-indigo-600"
            style={{ width: '0%' }}
          />
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium text-purple-200">Recompensas</h3>
        <div className="grid gap-4">
          {rewards.map((reward, index) => {
            const Icon = reward.icon;
            return (
              <div
                key={index}
                className={`bg-white/10 backdrop-blur-lg rounded-lg p-4 flex items-center space-x-4 ${
                  reward.unlocked ? 'border border-purple-500/30' : 'opacity-70'
                }`}
              >
                <div className="p-3 bg-purple-500/20 rounded-lg">
                  <Icon className="w-6 h-6 text-purple-300" />
                </div>
                <div>
                  <h4 className="font-medium text-purple-200">{reward.title}</h4>
                  <p className="text-sm text-purple-200/70">{reward.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex flex-col items-center space-y-4 mt-8">
        <p className="text-center text-purple-200/70">
          Compartilhe nas suas redes sociais
        </p>
        <Button
          variant="primary"
          icon={<Share2 className="w-4 h-4" />}
          onClick={() => toast.info('Recompensas de indicação em breve')}
        >
          Compartilhar
        </Button>
      </div>
    </div>
  );
};